const problems = [
  {
    icon: "ri-money-dollar-circle-line",
    title: "Parcelas que só crescem",
    description:
      "Você paga todos os meses, mas a dívida parece não diminuir. Os juros compostos devoram cada pagamento.",
  },
  {
    icon: "ri-percent-line",
    title: "Juros acima do limite legal",
    description:
      "Bancos frequentemente cobram taxas muito acima do permitido, especialmente em crédito pessoal e financiamentos.",
  },
  {
    icon: "ri-exchange-dollar-line",
    title: "Endividamento crescente",
    description:
      "A bola de neve da dívida bancária cresce mês a mês, comprometendo sua renda e qualidade de vida.",
  },
  {
    icon: "ri-file-unknow-line",
    title: "Falta de transparência",
    description:
      "Contratos confusos, cláusulas abusivas e cobranças que você nunca conseguiu entender de onde vieram.",
  },
];

export default function Problema() {
  return (
    <section id="problema" className="py-24 bg-[#1A1A1A]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="max-w-2xl mb-16">
          <span className="text-[#B32025] text-xs font-semibold uppercase tracking-widest font-sans">
            Você reconhece isso?
          </span>
          <h2 className="font-serif text-white text-3xl lg:text-4xl font-bold mt-3 mb-5">
            A realidade de quem enfrenta
            <br />
            <em className="text-[#B32025] not-italic">juros abusivos</em>
          </h2>
          <p className="text-[#BFBFBF] text-base leading-relaxed font-sans">
            Milhões de brasileiros pagam mais do que deveriam todos os meses sem saber que têm direito à revisão de juros.
          </p>
        </div>

        {/* Problem cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {problems.map((p) => (
            <div
              key={p.title}
              className="group bg-[#2C2C2C] hover:bg-[#B32025]/10 border border-white/5 hover:border-[#B32025]/30 rounded-lg p-6 transition-all duration-300 cursor-default"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-[#B32025]/10 group-hover:bg-[#B32025]/20 rounded-lg mb-5 transition-colors">
                <i className={`${p.icon} text-2xl text-[#B32025] leading-none`} />
              </div>
              <h3 className="text-white font-serif text-lg font-semibold mb-3">{p.title}</h3>
              <p className="text-[#BFBFBF] text-sm leading-relaxed font-sans">{p.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom message */}
        <div className="relative bg-[#B32025] rounded-lg px-8 py-10 overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -translate-y-1/2 translate-x-1/2" />
          <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <p className="text-white/70 text-sm font-sans uppercase tracking-widest mb-2">A boa notícia</p>
              <h3 className="font-serif text-white text-2xl lg:text-3xl font-bold">
                Você não precisa aceitar isso.
              </h3>
              <p className="text-white/80 text-base font-sans mt-2">
                A lei protege o consumidor contra <strong>juros abusivos</strong> e revisão de contratos bancários é um direito seu.
              </p>
            </div>
            <a
              href="https://wa.me/5554996914900?text=Ol%C3%A1%2C%20gostaria%20de%20uma%20an%C3%A1lise%20do%20meu%20contrato%20banc%C3%A1rio."
              target="_blank"
              rel="noopener noreferrer"
              className="flex-shrink-0 bg-white text-[#B32025] font-semibold px-8 py-4 rounded-md hover:bg-[#E6E6E6] transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              Entender meus direitos
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
